import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import BaseViewStore from 'base-viewstore';
import BaseComponent from 'base-component';

import c3 from 'c3';
import numeral from 'numeral';

export class GraphViewStore extends BaseViewStore {

  @observable validContent = true;
  @observable contentModelErrors = "";

  valid = true;
  prevChartData = [];
  chart = null;

  constructor(props) {
    super(props);

    if(this.props.form) {
        this.props.form.controls.push(this);
    }
    
    let contentModel = this.props.contentModel;
    for(let i = 0; i < contentModel.datasets.length; ++i) {
            
        let newSet = [];
        const splitValues = contentModel.datasets[i].values.split(",");
        for(let j = 0; j < splitValues.length; ++j) {
            let value = splitValues[j].trim();
            if(value.indexOf("G:") == 0) {
                if(value.indexOf(":-1") >= 0) {
                    value = value.replace(":-1", ":" + (window.application.dataModel.domainStore.context.team.num5 - 1));
                }
                else if(value.indexOf(":+0") >= 0) {
                    value = value.replace(":+0", ":" + (window.application.dataModel.domainStore.context.team.num5));
                }
            }
            newSet.push(value);
        }
        contentModel.datasets[i].values = newSet.join(",");       
    }
  }

  // validation is a derivation
  @computed get invalid(){
    const invalid = {};
    return invalid;
  }

  @action.bound save() {
  }

  @action.bound update() {

    if(!this.chart) {
      return;
    }

    const {
      contentModel,
      inputStore
    } = this.props;

    const {
      datasets,
    } = contentModel;

    self.validContent = true;
    self.contentModelErrors = "";

    let data = [];

    if(datasets.length == 0) {
      this.validContent = false;
      this.contentModelErrors = "Graph must have at least one dataset.";
      return;
    }

    let valueTotal = 0;
    for(let i = 0; i < datasets.length; ++i) {
      const dataset = datasets[i];

      let label = dataset.label || ("data" + 1);
      
      let values = this.createColumn(label, dataset.values);
      if(!values) { return; }
      data.push(values);
      
      for(let j = 0; j < values.length; ++j) {
        if(!isNaN(parseFloat(values[j])) && isFinite(values[j])) {
          valueTotal += parseFloat(values[j]);
        }
      }
    }
    
    if(datasets[0].graphType == "donut") {
        let leftOver = 100 - valueTotal;
        if(leftOver <= 0) { leftOver = 0; }
        if(leftOver >= 100) { leftOver = 100; }
        data.push(["Unallocated", leftOver]);
    }

    let wasChanged = false;
    for(let i = 0; i < data.length; ++i) {
      for(let j = 0; j < data[i].length; ++j) {
        if(!this.prevChartData[i] || !this.prevChartData[i][j] || this.prevChartData[i][j] != data[i][j]) {
          wasChanged = true;
          break;
        }
      }
      if(wasChanged) {
        break;
      }
    }

    this.prevChartData = data;

    this.chart.load({
      columns: data,
    });
  }

  createColumn(label, values) {
    
    let outValues = [label];
    const splitValues = values.split(",");
    for(let j = 0; j < splitValues.length; ++j) {
      let value = splitValues[j].trim();
      try {
        let number = parseFloat(value);
        if(!isNaN(number)) {
          value = number;
        }
        else if(this.props.form && this.props.form.dbVariableStore && this.props.form.dbVariableStore.hasOwnProperty(value)) {
          value = this.props.form.dbVariableStore[value];
        }
      }
      catch(e) {
        self.validContent = false;
        self.contentModelErrors = "Error while parsing dataset - " + e;
        return null;
      }

      outValues.push(value);
    }

    return outValues;
  }

  @action.bound renderGraph() {

    let self = this;

    const {
      contentModel,
      inputStore
    } = this.props;

    const {
      id,
      title,
      datasets,
      yLabel,
      yTickFormat,
      xTickLabels,
      showLegend,
      showTooltip,
      forceWidth,
      forceHeight,
    } = contentModel;

    let config = {
      bindto: "#" + id + "-graph-element",
      data: {
        columns: [],
        types: {},
      }
    }

    self.validContent = true;
    self.contentModelErrors = "";

    if(datasets.length == 0) {
      this.validContent = false;
      this.contentModelErrors = "Graph must have at least one dataset.";
      return;
    }

    let valueTotal = 0;
    for(let i = 0; i < datasets.length; ++i) {
      const dataset = datasets[i];

      let label = dataset.label || ("data" + 1);
      
      let values = this.createColumn(label, dataset.values);
      if(!values) { return; }
      config.data.columns.push(values);
      config.data.types[label] = dataset.graphType;

      for(let j = 0; j < values.length; ++j) {
          if(!isNaN(parseFloat(values[j])) && isFinite(values[j])) {
            valueTotal += parseFloat(values[j]);
          }
      }

      if(dataset.color && dataset.color != 'auto') {
        if(!config.data.colors) { config.data.colors = {}; }

        config.data.colors[label] = dataset.color;
      }
    }

    if(datasets[0].graphType == "donut") {
        const leftOver = 100 - valueTotal;
        if(leftOver <= 100 && leftOver >= 0) {
            config.data.columns.push(["Unallocated", leftOver]);
            config.data.types["Unallocated"] = "donut";
            config.data.colors["Unallocated"] = "#d0d0d0";
        }
    }

    this.prevChartData = config.data;

    if(yLabel && yLabel.length > 0) {
      if(!config.axis) { config.axis = {}; }
      if(!config.axis.y) { config.axis.y = {}; }
      if(!config.axis.y.label) { config.axis.y.label = {}; }

      config.axis.y.label.text = yLabel;
      config.axis.y.label.position = 'outer-middle';
    }

    if(yTickFormat && yTickFormat.length > 0 && yTickFormat != "numeral.js format") {
      if(!config.axis) { config.axis = {}; }
      if(!config.axis.y) { config.axis.y = {}; }
      if(!config.axis.y.tick) { config.axis.y.tick = {}; }

      config.axis.y.tick.format = (v) => { 
            if(yTickFormat.indexOf("%") >= 0) {
                v /= 100;
            }
            return numeral(v).format(yTickFormat); 
        }; 
    }

    const yMin = parseFloat(contentModel.yMin);
    const yMax = parseFloat(contentModel.yMax);
    if(yMin != -1 && !isNaN(yMin)) {
      if(!config.axis) { config.axis = {}; }
      if(!config.axis.y) { config.axis.y = {}; }
      if(!config.axis.y.padding) { config.axis.y.padding = {}; }

      config.axis.y.min = yMin;
      config.axis.y.padding.bottom = 0;
    }
    
    if(yMax != -1 && !isNaN(yMax) && (!(yMin != -1 && !isNaN(yMin)) || yMin < yMax)) {
      if(!config.axis) { config.axis = {}; }
      if(!config.axis.y) { config.axis.y = {}; }
      if(!config.axis.y.padding) { config.axis.y.padding = {}; }

      config.axis.y.max = yMax;
      config.axis.y.padding.top = 0;
    }

    if(xTickLabels && xTickLabels.length > 0 && xTickLabels != "Comma separated values") {
      if(!config.axis) { config.axis = {}; }
      if(!config.axis.x) { config.axis.x = {}; }

      let values = this.createColumn("x", xTickLabels);
      if(!values) { return; }
      values.shift(); // remove the label because we don't need it here

      config.axis.x.type = 'category';
      config.axis.x.categories = values;
    }

    if(!showLegend) {
      if(!config.legend) { config.legend = {}; }
      config.legend.show = false;

      if(datasets[0].graphType == "donut") {
        config.donut = {
            label: {
                show: false,
            }
        }
      }
    }
    if(!showTooltip) {
      if(!config.tooltip) { config.tooltip = {}; }
      config.tooltip.show = false;
    }

    if(forceWidth) {
        const width = parseFloat(forceWidth);
        if(!isNaN(width) && isFinite(width) && width > 0) {
            if(!config.size) { config.size = {}; }
            config.size.width = width;
        }
    }
    if(forceHeight) {
        const height = parseFloat(forceHeight);
        if(!isNaN(height) && isFinite(height) && height > 0) {
            if(!config.size) { config.size = {}; }
            config.size.height = height;
        }
    }

    this.chart = c3.generate(config);
  }
}

@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
@autoclass // this automatically gives consistent `className`s to components using module and component names
export class GraphComponent extends BaseComponent {

  static ViewStore = GraphViewStore; //ViewStore gets auto-instantiated and attached to the component on creation

  componentWillMount() {
    // TODO: load data from the database
  }

  render() {
    const {
      currentView,
      contentModel,
      inputStore
    } = this.props;

    const {
      id,
      css,
      title,
      datasets
    } = contentModel;

    const {
      validContent,
      contentModelErrors,
      invalid,
      save
    } = this.viewStore; // this components viewStore.  Will have actions and UI properties

    const isDirty = inputStore && inputStore.isDirty;
    const isLoading = inputStore && inputStore.isLoading;
    const revert = inputStore ? inputStore.revert : function() {};

    if(isLoading) return <div>Loading...</div>;
    if(!validContent) return <div>Invalid content model. {contentModelErrors}</div>;

    if(datasets && datasets[0] && title) {
        return (<div className={"graph-activity " + css + " " + datasets[0].graphType}>
          <div className="graph-title" dangerouslySetInnerHTML={{__html: title}}></div>
          <div id={id + "-graph-element"} className="graph"></div>
        </div>)
    }

    return (<div className={"graph-activity " + css}>
      <div id={id + "-graph-element"} className="graph"></div>
    </div>)
  }

  componentDidMount() {
    this.viewStore.renderGraph();
  }

  componentDidUpdate() {
  }
}
export default GraphComponent; //need to export top level component as "default"



// WEBPACK FOOTER //
// ./app_modules/graph-activity/src/component.js